import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { BsArrowRight } from "react-icons/bs";
import { motion } from "framer-motion";

const GetDiscovered = () => {
  return (
    <div className="py-5">
      <Container>
        <div className="p-5" style={{ background: 'radial-gradient(circle at 10% 20%, rgba(176, 66, 255, 0.15) 0%, transparent 40%), radial-gradient(circle at 90% 30%, rgb(0 1 2) 0%, transparent 40%)', borderRadius: '24px', border: '1px solid #222' }}>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-lg-0 pe-lg-5">
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                <h2 className="text-white fw-bold mb-4" style={{ fontSize: '2.5rem' }}>
                  Your Trusted Partner for <br />
                  <span style={{ color: '#b042ff' }}>Music Video</span> Releases
                </h2>
                <div style={{ width: '40px', height: '4px', background: 'linear-gradient(90deg, #b042ff, #ff7e5f)', marginBottom: '24px', borderRadius: '2px' }}></div>
                <p style={{ color: '#aaa', fontSize: '15px', lineHeight: '1.6', marginBottom: '20px' }}>
                  Our official music video release partner is dedicated to bringing your creative vision to life. With industry-leading expertise, we ensure your music videos reach the right audience, amplifying your impact across platforms.
                </p>
                <p style={{ color: '#aaa', fontSize: '15px', lineHeight: '1.6', marginBottom: '32px' }}>
                  Trust in our partner for seamless releases, maximizing exposure and success in the competitive music landscape.
                </p>
                <a
                  className="btn text-white px-4 py-2 d-inline-flex align-items-center gap-2 fw-bold"
                  style={{ borderRadius: '50px', border: '1px solid #fff', fontSize: '12px', letterSpacing: '1px' }}
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  SIGN UP NOW <BsArrowRight size={16} />
                </a>
              </motion.div>
            </Col>
            <Col lg={6} className="text-center">
              <motion.img
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                alt="Music Video Release"
                className="img-fluid"
                style={{ borderRadius: "12px", boxShadow: "0 20px 40px rgba(0,0,0,0.5)" }}
                src="/Images/Distribution_Image.png"
              />
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default GetDiscovered;
